// Enums mirroring Prisma schema enums for frontend usage
// These should match the backend Prisma schema exactly

export type Role = "CUSTOMER" | "ADMIN" | "STAFF";

export type Type = "SUBSCRIPTION" | "PACKAGE";

export type Category = "OCCASIONAL" | "REGULAR" | "LOYAL";

export type SubscriptionName = "SILVER" | "GOLD" | "PLATINUM";

export type PaymentMode =
  | "CASH"
  | "BANK_TRANSFER"
  | "POS"
  | "CREDIT_CARD"
  | "DEBIT_CARD"
  | "APPLE_PAY"
  | "G_PAY"
  | "WALLET";

export type AppoinmentType = "PACKAGE" | "USER_SUBSCRIPTION";

// Appointment status values accepted by the API. Mirrors
// backend/src/constants/appointmentStatus.ts — keep the two in sync.
// `Appoinment.status` is a plain String column in Prisma, so this list is the
// only thing keeping the UI and the API in agreement.
export const APPOINTMENT_STATUSES = [
  "PENDING",
  "CONFIRMED",
  "IN_PROGRESS",
  "COMPLETED",
  "NOT_COMPLETED",
  "POSTPONED",
  "CANCELLED",
] as const;

export type AppointmentStatus = (typeof APPOINTMENT_STATUSES)[number];

/**
 * Kebab-case status values from the pre-migration UI. These are NOT valid API
 * values — they are only accepted as input to `mapFrontendStatusToBackend`,
 * which translates them before anything is sent to the backend. Keeping them
 * out of `AppointmentStatus` is what stops them leaking into API payloads.
 */
export type LegacyAppointmentStatus =
  | "confirmation-pending"
  | "confirmed"
  | "completed"
  | "cancelled"
  | "in-progress"
  | "not-completed"
  | "postponed"
  | "on-the-way"
  | "no-answer"
  | "no-booking"
  | "not-available";

/** Display order and labels for every status picker in the app. */
export const APPOINTMENT_STATUS_OPTIONS: {
  value: AppointmentStatus;
  label: string;
}[] = [
  { value: "PENDING", label: "Pending" },
  { value: "CONFIRMED", label: "Confirmed" },
  { value: "IN_PROGRESS", label: "In Progress" },
  { value: "COMPLETED", label: "Completed" },
  { value: "NOT_COMPLETED", label: "Not Completed" },
  { value: "POSTPONED", label: "Postponed" },
  { value: "CANCELLED", label: "Cancelled" },
];

export function isAppointmentStatus(
  value: string,
): value is AppointmentStatus {
  return (APPOINTMENT_STATUSES as readonly string[]).includes(value);
}
